'use strict';
import Swiper from 'swiper/js/swiper.min.js';

//-------------------------------------------------------
// INIT using routes in main.js
//-------------------------------------------------------
export default {
  init() {
    new Product();
    new HeroSwiper();
    new GallerySwiper();
    new CaseStudiesSwiper();
  },
};

//-------------------------------------------------------
// Hero Swiper
//-------------------------------------------------------
function HeroSwiper()
{
  let self = this;

  this.init = function() {
    self.galleryThumbs = jQuery('.gallery-thumbnail');
    self.gallery = new Swiper('.gallery-top', {
      effect: 'fade',
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    self.eventListeners();
  };

  this.eventListeners = function () {
    self.galleryThumbs.each(function () {
      jQuery(this).on('click', function () {
        self.onClick(jQuery(this));
      });
    });
  };

  this.onClick = function(item) {
    let targetId = item.data('count');
    self.gallery[0].slideTo(targetId);
    self.gallery[1].slideTo(targetId);
    self.removeActive();
    item.addClass('active');
  };

  this.removeActive = function() {
    self.galleryThumbs.each(function () {
      jQuery(this).removeClass('active');
    });
  };

  setTimeout(self.init, 1000);
}

//-------------------------------------------------------
// Gallery Swiper
//-------------------------------------------------------
function GallerySwiper()
{
  let self = this;

  this.init = function() {
    self.gallery = new Swiper('.gallery-slide', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
    });
  };

  setTimeout(self.init, 1000);
}

//-------------------------------------------------------
// Case Studies Swiper
//-------------------------------------------------------
function CaseStudiesSwiper()
{
  let self = this;

  this.init = function() {
    self.gallery = new Swiper('.case-studies-slide', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 20,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1800: {
          slidesPerView: 6,
          spaceBetween: 50,
        },
      },
    });
  };

  self.init();
}

//-------------------------------------------------------
// Product
//-------------------------------------------------------
function Product()
{
  let self = this;
  self.timer = null;

  this.init = function () {
    self.siteNav = document.getElementById('navigation');
    self.productNav = document.getElementById('product-nav');
    self.productNavActual = document.getElementById('product-nav-actual');
    self.items = jQuery('#product-nav-actual').find('.item');
    self.sections = jQuery('section.section');
    self.eventListeners();
    self.onScroll();
    self.housekeeping();
  };

  this.eventListeners = function () {
    self.items.each(function () {
      jQuery(this).on('click', function () {
        self.onClick(jQuery(this));
      });
    });

    window.addEventListener('scroll', function() {
      self.onScroll();
    });
  };

  this.sticky = function() {
    let stickyDistance = self.productNav.offsetTop - self.siteNav.offsetHeight;
    let stickyActive = ((self.scrollTopValue - stickyDistance) > 0);

    if(stickyActive)
    {
      self.productNav.classList.add('sticky');
      self.productNavActual.style.top = self.siteNav.offsetHeight+'px';
    }
    else
    {
      self.productNav.classList.remove('sticky');
    }
  };

  this.scrollTop = function() {
    return (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
  };

  this.navbarHeight = function () {
    if(self.width() < 992)
      return self.siteNav.offsetHeight;

    return self.siteNav.offsetHeight + self.productNavActual.offsetHeight;
  };

  this.width = function() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  };

  this.startTimer = function() {
    self.timer = window.setTimeout(function() {
      self.sticky();
    }, 700);
  };

  this.onScroll = function() {
    self.scrollTopValue = self.scrollTop();
    self.checkSections();
    self.sticky();
    //clearTimeout(self.timer);
    //self.startTimer();
  };

  this.onClick = function(item) {
    let targetId = item.data('target');
    let target = document.getElementById(targetId);
    let targetDistance = target.offsetTop - self.navbarHeight();
    window.scrollTo({ top: targetDistance, behavior: 'smooth' });
    self.onScroll();
  };

  this.checkSections = function() {
    let active = null;

    self.sections.each(function () {
      let sectionDistance = jQuery(this).offset().top - self.navbarHeight();
      let sectionActive = ((self.scrollTopValue - sectionDistance) >= 0);
      if(sectionActive)
        active = jQuery(this).attr('id');
    });

    self.items.each(function () {
      jQuery(this).removeClass('active');
      if(jQuery(this).data('target') === active)
        jQuery(this).addClass('active');
    });
  };

  this.housekeeping = function() {
    setTimeout(self.onScroll, 1000);
  };

  self.init();
}



// WEBPACK FOOTER //
// ./scripts/routes/product.js